module.exports = __webpack_public_path__ + "img/icon_flame.6fead1e4.svg";